export default "__VITE_ASSET__3c1c9c09__"